<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gdKNYY/tc-custom/FC-9781528967877.jpg?1685327485950?1709061671806" alt="This image is the cover for the book The Deadly Highway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Deadly Highway
      </h1>
      <p class="bookDescription body article font2">
        <p>Lucy is escaping her unusual home lifestyle. She is in for shock and horror at the same time. Lucy isn't prepared for what is going to unfold before her on this journey. A story of gaining a friend and an enemy at the same time. A seemingly comfortable, yet dark path to hell. Lucy will question her life--life that will never be the same again. There will be a trio that have escaped their lives from home and she can confide in one of them as the others are not what she expected them to be. They will make her life a living hell. When she thinks she has finally escaped, she will learn that she hasn't. How much torment can she actually take? She is going to wish she stayed with her life at home. What a life for a young teenage girl. But why does it all happen?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        T. Harrogate
      </h2>
      
      <p class="authorDescription body article">T. Harrogate lives in County Cork and was born in Harrogate in Yorkshire. She works as a healthcare assistant. She really enjoys her job. She also enjoys writing murder mystery stories. The author started writing when she was sixteen but never did anything with the stories back then. She loves writing. This is her second book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?725e2b5e